<template>
  <div class="layout-main">
    <div class="main-inner">
      <keep-alive>
        <router-view :key="key" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <keep-alive :include="[]">
        <router-view :key="key" v-if="!$route.meta.keepAlive" />
      </keep-alive>
      <!-- <MenuBtnTools />  -->
    </div>
  </div>
</template>
<script>
// import MenuBtnTools from "@/components/menuBtnTools/Index.vue"
export default {
  name: "layout-main",
  components: {
    // MenuBtnTools,
  },
  data: function () {
    return {};
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>
<style lang="scss" scoped>
.layout-main {
  display: flex;
  .main-inner {
    width: 100%;
    min-height: 100%;
    min-width: 1020px;
    display: flex;
    justify-content: center;
  }
  .main-inner > div {
    width: 60%;
    padding: 10px 0;
    min-width: inherit;
  }
}
</style>
